// PostcodeAnywhere / Loqate client-side address lookup. Same key + endpoints
// as the existing quick-form.php; key is scoped to the Breeze Workspace and
// already visible in existing client code, so we keep it here for parity.

const PCA_KEY = "rh99-au66-em81-uh13";

export type PcaFindItem = {
  Id: string;
  Text: string;
  Description: string;
  Next: string;
};

export type PcaRetrieveItem = {
  Company: string;
  Line1: string;
  Line2: string;
  Line3: string;
  City: string;
  PostalCode: string;
};

export async function pcaFind(term: string): Promise<PcaFindItem[]> {
  const url =
    "https://services.postcodeanywhere.co.uk/CapturePlus/Interactive/Find/v2.10/json3.ws?" +
    `Key=${encodeURIComponent(PCA_KEY)}&SearchTerm=${encodeURIComponent(term)}&Country=GBR`;
  const res = await fetch(url);
  const data = (await res.json()) as { Items?: PcaFindItem[]; Error?: string };
  if (data.Error) throw new Error(data.Error);
  // PCA returns both "Container" entries (pick-a-street) and retrievable
  // addresses. We only surface the retrievable ones.
  return (data.Items ?? []).filter((i) => i.Next === "Retrieve");
}

export async function pcaRetrieve(id: string): Promise<PcaRetrieveItem | null> {
  const url =
    "https://services.postcodeanywhere.co.uk/CapturePlus/Interactive/Retrieve/v2.10/json3.ws?" +
    `Key=${encodeURIComponent(PCA_KEY)}&Id=${encodeURIComponent(id)}`;
  const res = await fetch(url);
  const data = (await res.json()) as { Items?: PcaRetrieveItem[] };
  return data.Items?.[0] ?? null;
}
